// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import 'fullpage.js/vendors/scrolloverflow';
import VueFullPage from 'vue-fullpage.js';
import '../src/assets/magic.css'
import 'hover.css'
import particles from 'particles.js'
Vue.use(particles)
Vue.config.productionTip = false
Vue.use(Antd);
Vue.use(ElementUI);
Vue.use(VueFullPage);

/* eslint-disable no-new */
axios.defaults.baseURL='https://www.steppyplus.com/api/'
Vue.prototype.$axios = axios
new Vue({
  el: '#app',
  axios,
  router,
  Antd,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js